import { VP_FIXED_DESTINATION_SECTIONS } from "./vacationPackagesDiscovery/vpFixedDestinationSections";

/** v3: בלוקי יעד קבועים (dest_*) במקום packages/organized */
const STORAGE_KEY = "hr_vp_home_discovery_v3";
/** TTL לרענון רקע; מציגים גם נתונים ישנים יותר (stale-while-revalidate) */
export const DISCOVERY_HOME_CACHE_TTL_MS = 10 * 60 * 1000;

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function emptyDestPayload() {
  return VP_FIXED_DESTINATION_SECTIONS.reduce((acc, d) => {
    acc[d.id] = [];
    return acc;
  }, {});
}

/**
 * קריאת מטמון לתצוגה מיידית — גם אם פג ה-TTL (SWR).
 */
export function readDiscoveryHomeCacheEntry() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = safeParse(raw);
    if (!o || typeof o !== "object") return null;
    const dest = emptyDestPayload();
    VP_FIXED_DESTINATION_SECTIONS.forEach((d) => {
      if (Array.isArray(o[d.id])) dest[d.id] = o[d.id];
    });
    return {
      flights: Array.isArray(o.flights) ? o.flights : [],
      ...dest,
      savedAt: typeof o.savedAt === "number" ? o.savedAt : 0,
    };
  } catch {
    return null;
  }
}

export function isDiscoveryHomeCacheFresh(savedAt) {
  if (!savedAt) return false;
  return Date.now() - savedAt < DISCOVERY_HOME_CACHE_TTL_MS;
}

function readRawObject() {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const o = safeParse(raw);
    return o && typeof o === "object" ? o : {};
  } catch {
    return {};
  }
}

export function mergeDiscoveryHomeCachePartial(partial) {
  if (typeof window === "undefined") return;
  try {
    const prev = readRawObject();
    const next = {
      ...prev,
      ...partial,
      savedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    if (e?.name === "QuotaExceededError") {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        /* ignore */
      }
    }
  }
}

export function writeDiscoveryHomeCacheFull(payload) {
  if (typeof window === "undefined" || !payload) return;
  const d = emptyDestPayload();
  VP_FIXED_DESTINATION_SECTIONS.forEach((sec) => {
    if (Array.isArray(payload[sec.id])) d[sec.id] = payload[sec.id];
  });
  mergeDiscoveryHomeCachePartial({
    flights: payload.flights ?? [],
    ...d,
  });
}
